import React, { Component } from "react";
import PropTypes from "prop-types";
import InputRow from "./InputRow";
import Loading from "./Loading";
export default class AcademicInterest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,

      entryTermData: [],
      selectedEntryTerm: 0,
      universityData: [],

      selectedUniversity: 0,
      selectedProgram: 1,
      selectedMajor: 0,
      majorsData: [],
      languagesData: [],
      selectedLanguage: 0,

      selectedSecondUniversity: 0,
      selectedSecondMajor: 0,
      selectedSecondLanguage: 0,
      majorsSecondData: [],
      languagesSecondData: [],

      selectedThirdUniversity: 0,
      selectedThirdMajor: 0,
      selectedThirdLanguage: 0,
      majorsThirdData: [],
      languagesThirdData: [],

      majorCount: 1,
    };

    this.handleCollegeSelect2 = this.handleCollegeSelect2.bind(this);
    this.handleCollegeSelect = this.handleCollegeSelect.bind(this);
    this.fetchMajor2 = this.fetchMajor2.bind(this);
    this.fetchMajor = this.fetchMajor.bind(this);
    this.fetchLanguage2 = this.fetchLanguage2.bind(this);
    this.fetchLanguage = this.fetchLanguage.bind(this);

    this.handleSecondCollegeSelect2 =
      this.handleSecondCollegeSelect2.bind(this);
    this.handleSecondCollegeSelect = this.handleSecondCollegeSelect.bind(this);
    this.fetchSecondMajor2 = this.fetchSecondMajor2.bind(this);
    this.fetchSecondMajor = this.fetchSecondMajor.bind(this);
    this.fetchSecondLanguage2 = this.fetchSecondLanguage2.bind(this);
    this.fetchSecondLanguage = this.fetchSecondLanguage.bind(this);

    this.handleThirdCollegeSelect2 = this.handleThirdCollegeSelect2.bind(this);
    this.handleThirdCollegeSelect = this.handleThirdCollegeSelect.bind(this);
    this.fetchThirdMajor2 = this.fetchThirdMajor2.bind(this);
    this.fetchThirdMajor = this.fetchThirdMajor.bind(this);
    this.fetchThirdLanguage2 = this.fetchThirdLanguage2.bind(this);
    this.fetchThirdLanguage = this.fetchThirdLanguage.bind(this);
  }

  componentDidMount() {
    fetch(`${process.env.REACT_APP_API_URL}/api/AcademicInterest/GetEntryTerm`)
      .then((res) => res.json())
      .then((res) => {
        this.setState({
          entryTermData: res,
          selectedEntryTerm: this.props.entryTerm || 0,
        });
      })
      .catch((err) => console.log(err))
      .then(() => {
        fetch(
          `${process.env.REACT_APP_API_URL}/api/AcademicInterest/GetColleges`
        )
          .then((res) => res.json())
          .then((res) => {
            this.setState({
              universityData: res,
              selectedUniversity: this.props.selectedUniversity,
              selectedSecondUniversity: this.props.selectedSecondUniversity,
              selectedThirdUniversity: this.props.selectedThirdUniversity,
              loading: false,
            });
          })
          .then(() => {
            if (this.props.selectedUniversity) {
              this.handleCollegeSelect2(this.props.selectedUniversity);
            }
            if (this.props.selectedMajor) {
              this.fetchLanguage2(this.props.selectedMajor);
            }

            if (this.props.selectedSecondUniversity) {
              this.handleSecondCollegeSelect2(
                this.props.selectedSecondUniversity
              );
            }
            if (this.props.selectedSecondMajor) {
              this.fetchSecondLanguage2(this.props.selectedSecondMajor);
            }

            if (this.props.selectedThirdUniversity) {
              this.handleThirdCollegeSelect2(
                this.props.selectedThirdUniversity
              );
            }
            if (this.props.selectedThirdMajor) {
              this.fetchThirdLanguage2(this.props.selectedThirdMajor);
            }
          })
          .catch((err) => console.log(err));
      });
  }

  // #region First Major
  handleCollegeSelect(e) {
    this.setState({ selectedUniversity: e }, () => {
      this.fetchMajor(this.state.selectedUniversity);
    });
  }

  handleCollegeSelect2(e) {
    this.setState({ selectedUniversity: e }, () => {
      if (this.props.selectedUniversity === null) {
        this.fetchMajor2(1000, 1);
      } else {
        this.fetchMajor2(this.props.selectedUniversity, 1);
      }
    });
  }

  fetchLanguage(majorId) {
    fetch(
      `${process.env.REACT_APP_API_URL}/api/AcademicInterest/GetLanguages?programOfStudyId=${majorId}`
    )
      .then((res) => res.json())
      .then((res) => {
        this.setState({
          languagesData: res,
          selectedLanguage: res.length === 1 ? res[0].Id : "",
          loading: false,
        });
        this.props.collectState("AI", {
          selectedEntryTerm: this.state.selectedEntryTerm,

          selectedMajor: this.state.selectedMajor,
          selectedUniversity: this.state.selectedUniversity,
          selectedLanguage: this.state.selectedLanguage,

          selectedSecondMajor: this.state.selectedSecondMajor,
          selectedSecondUniversity: this.state.selectedSecondUniversity,
          selectedSecondLanguage: this.state.selectedSecondLanguage,

          selectedThirdMajor: this.state.selectedThirdMajor,
          selectedThirdUniversity: this.state.selectedThirdUniversity,
          selectedThirdLanguage: this.state.selectedThirdLanguage,
          selectedProgram: 1,
        });
      })
      .catch((err) => console.log(err));
  }

  fetchLanguage2(majorId) {
    fetch(
      `${process.env.REACT_APP_API_URL}/api/AcademicInterest/GetLanguages?programOfStudyId=${majorId}`
    )
      .then((res) => res.json())
      .then((res) => {
        this.setState({
          languagesData: res,
          selectedLanguage:
            res.length === 1 ? res[0].Id : this.props.selectedLanguage,
          loading: false,
        });
        this.props.collectState("AI", {
          selectedEntryTerm: this.state.selectedEntryTerm,

          selectedMajor: this.state.selectedMajor,
          selectedUniversity: this.state.selectedUniversity,
          selectedLanguage: this.state.selectedLanguage,

          selectedSecondMajor: this.state.selectedSecondMajor,
          selectedSecondUniversity: this.state.selectedSecondUniversity,
          selectedSecondLanguage: this.state.selectedSecondLanguage,

          selectedThirdMajor: this.state.selectedThirdMajor,
          selectedThirdUniversity: this.state.selectedThirdUniversity,
          selectedThirdLanguage: this.state.selectedThirdLanguage,
          selectedProgram: 1,
        });
      })
      .catch((err) => console.log(err));
  }

  fetchMajor2(collegeId) {
    fetch(
      `${process.env.REACT_APP_API_URL}/api/AcademicInterest/GetMajors?collegeId=${collegeId}`
    )
      .then((res) => res.json())
      .then((res) => {
        this.setState({ majorsData: res });
        this.setState({
          selectedMajor: this.props.selectedMajor,
          selectedLanguage: this.props.selectedLanguage,
          loading: false,
        });
        this.props.collectState("AI", {
          selectedEntryTerm: this.props.entryTerm,
          selectedMajor: this.props.selectedMajor,
          selectedUniversity: this.props.selectedUniversity,
          selectedLanguage: this.props.selectedLanguage,

          selectedSecondMajor: this.props.selectedSecondMajor,
          selectedSecondUniversity: this.props.selectedSecondUniversity,
          selectedSecondLanguage: this.props.selectedSecondLanguage,

          selectedThirdMajor: this.props.selectedThirdMajor,
          selectedThirdUniversity: this.props.selectedThirdUniversity,
          selectedThirdLanguage: this.props.selectedThirdLanguage,
          selectedProgram: 1,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  fetchMajor(collegeId) {
    fetch(
      `${process.env.REACT_APP_API_URL}/api/AcademicInterest/GetMajors?collegeId=${collegeId}`
    )
      .then((res) => res.json())
      .then((res) => {
        this.setState({ majorsData: res });

        this.setState({
          selectedMajor: "",
          selectedLanguage: "",
          loading: false,
        });

        this.props.collectState("AI", {
          selectedEntryTerm: this.state.selectedEntryTerm,
          selectedMajor: "",
          selectedUniversity: this.state.selectedUniversity,
          selectedLanguage: "",

          selectedSecondMajor: this.state.selectedSecondMajor,
          selectedSecondUniversity: this.state.selectedSecondUniversity,
          selectedSecondLanguage: this.state.selectedSecondLanguage,

          selectedThirdMajor: this.state.selectedThirdMajor,
          selectedThirdUniversity: this.state.selectedThirdUniversity,
          selectedThirdLanguage: this.state.selectedThirdLanguage,
          selectedProgram: 1,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }
  // #endregion

  // #region Second Major
  handleSecondCollegeSelect(e) {
    this.setState({ selectedSecondUniversity: e }, () => {
      this.fetchSecondMajor(this.state.selectedSecondUniversity);
    });
  }

  handleSecondCollegeSelect2(e) {
    this.setState({ selectedSecondUniversity: e }, () => {
      if (this.props.selectedSecondUniversity === null) {
        this.fetchSecondMajor2(1000, 1);
      } else {
        this.fetchSecondMajor2(this.props.selectedSecondUniversity, 1);
      }
    });
  }

  fetchSecondLanguage(majorId) {
    fetch(
      `${process.env.REACT_APP_API_URL}/api/AcademicInterest/GetLanguages?programOfStudyId=${majorId}`
    )
      .then((res) => res.json())
      .then((res) => {
        this.setState({
          languagesSecondData: res,
          selectedSecondLanguage: res.length === 1 ? res[0].Id : "",
          loading: false,
        });
        this.props.collectState("AI", {
          selectedEntryTerm: this.state.selectedEntryTerm,

          selectedMajor: this.state.selectedMajor,
          selectedUniversity: this.state.selectedUniversity,
          selectedLanguage: this.state.selectedLanguage,

          selectedSecondMajor: this.state.selectedSecondMajor,
          selectedSecondUniversity: this.state.selectedSecondUniversity,
          selectedSecondLanguage: this.state.selectedSecondLanguage,

          selectedThirdMajor: this.state.selectedThirdMajor,
          selectedThirdUniversity: this.state.selectedThirdUniversity,
          selectedThirdLanguage: this.state.selectedThirdLanguage,
          selectedProgram: 1,
        });
      })
      .catch((err) => console.log(err));
  }

  fetchSecondLanguage2(majorId) {
    fetch(
      `${process.env.REACT_APP_API_URL}/api/AcademicInterest/GetLanguages?programOfStudyId=${majorId}`
    )
      .then((res) => res.json())
      .then((res) => {
        this.setState({
          languagesSecondData: res,
          selectedSecondLanguage:
            res.length === 1 ? res[0].Id : this.props.selectedSecondLanguage,
          loading: false,
        });
        this.props.collectState("AI", {
          selectedEntryTerm: this.state.selectedEntryTerm,

          selectedMajor: this.state.selectedMajor,
          selectedUniversity: this.state.selectedUniversity,
          selectedLanguage: this.state.selectedLanguage,

          selectedSecondMajor: this.state.selectedSecondMajor,
          selectedSecondUniversity: this.state.selectedSecondUniversity,
          selectedSecondLanguage: this.state.selectedSecondLanguage,

          selectedThirdMajor: this.state.selectedThirdMajor,
          selectedThirdUniversity: this.state.selectedThirdUniversity,
          selectedThirdLanguage: this.state.selectedThirdLanguage,
          selectedProgram: 1,
        });
      })
      .catch((err) => console.log(err));
  }

  fetchSecondMajor2(collegeId) {
    fetch(
      `${process.env.REACT_APP_API_URL}/api/AcademicInterest/GetMajors?collegeId=${collegeId}`
    )
      .then((res) => res.json())
      .then((res) => {
        this.setState({ majorsSecondData: res });
        this.setState({
          selectedSecondMajor: this.props.selectedSecondMajor,
          selectedSecondLanguage: this.props.selectedSecondLanguage,
          loading: false,
          majorCount: 2,
        });
        this.props.collectState("AI", {
          selectedEntryTerm: this.state.selectedEntryTerm,
          selectedMajor: this.state.selectedMajor,
          selectedUniversity: this.state.selectedUniversity,
          selectedLanguage: this.state.selectedLanguage,

          selectedSecondMajor: this.state.selectedSecondMajor,
          selectedSecondUniversity: this.state.selectedSecondUniversity,
          selectedSecondLanguage: this.state.selectedSecondLanguage,

          selectedThirdMajor: this.state.selectedThirdMajor,
          selectedThirdUniversity: this.state.selectedThirdUniversity,
          selectedThirdLanguage: this.state.selectedThirdLanguage,
          selectedProgram: 1,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  fetchSecondMajor(collegeId) {
    fetch(
      `${process.env.REACT_APP_API_URL}/api/AcademicInterest/GetMajors?collegeId=${collegeId}`
    )
      .then((res) => res.json())
      .then((res) => {
        this.setState({ majorsSecondData: res });

        this.setState({
          selectedSecondMajor: "",
          loading: false,
          selectedSecondLanguage: "",
        });

        this.props.collectState("AI", {
          selectedEntryTerm: this.state.selectedEntryTerm,
          selectedMajor: this.state.selectedMajor,
          selectedUniversity: this.state.selectedUniversity,
          selectedLanguage: this.state.selectedLanguage,

          selectedSecondMajor: "",
          selectedSecondUniversity: this.state.selectedSecondUniversity,
          selectedSecondLanguage: "",

          selectedThirdMajor: this.state.selectedThirdMajor,
          selectedThirdUniversity: this.state.selectedThirdUniversity,
          selectedThirdLanguage: this.state.selectedThirdLanguage,
          selectedProgram: 1,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }
  // #endregion

  // #region Third Major
  handleThirdCollegeSelect(e) {
    this.setState({ selectedThirdUniversity: e }, () => {
      this.fetchThirdMajor(this.state.selectedThirdUniversity);
    });
  }

  handleThirdCollegeSelect2(e) {
    this.setState({ selectedThirdUniversity: e }, () => {
      if (this.props.selectedThirdUniversity === null) {
        this.fetchThirdMajor2(1000, 1);
      } else {
        this.fetchThirdMajor2(this.props.selectedThirdUniversity, 1);
      }
    });
  }

  fetchThirdLanguage(majorId) {
    fetch(
      `${process.env.REACT_APP_API_URL}/api/AcademicInterest/GetLanguages?programOfStudyId=${majorId}`
    )
      .then((res) => res.json())
      .then((res) => {
        this.setState({
          languagesThirdData: res,
          selectedThirdLanguage: res.length === 1 ? res[0].Id : "",
          loading: false,
        });
        this.props.collectState("AI", {
          selectedEntryTerm: this.state.selectedEntryTerm,

          selectedMajor: this.state.selectedMajor,
          selectedUniversity: this.state.selectedUniversity,
          selectedLanguage: this.state.selectedLanguage,

          selectedSecondMajor: this.state.selectedSecondMajor,
          selectedSecondUniversity: this.state.selectedSecondUniversity,
          selectedSecondLanguage: this.state.selectedSecondLanguage,

          selectedThirdMajor: this.state.selectedThirdMajor,
          selectedThirdUniversity: this.state.selectedThirdUniversity,
          selectedThirdLanguage: this.state.selectedThirdLanguage,
          selectedProgram: 1,
        });
      })
      .catch((err) => console.log(err));
  }

  fetchThirdLanguage2(majorId) {
    fetch(
      `${process.env.REACT_APP_API_URL}/api/AcademicInterest/GetLanguages?programOfStudyId=${majorId}`
    )
      .then((res) => res.json())
      .then((res) => {
        this.setState({
          languagesThirdData: res,
          selectedThirdLanguage:
            res.length === 1 ? res[0].Id : this.props.selectedThirdLanguage,
          loading: false,
        });
        this.props.collectState("AI", {
          selectedEntryTerm: this.state.selectedEntryTerm,

          selectedMajor: this.state.selectedMajor,
          selectedUniversity: this.state.selectedUniversity,
          selectedLanguage: this.state.selectedLanguage,

          selectedSecondMajor: this.state.selectedSecondMajor,
          selectedSecondUniversity: this.state.selectedSecondUniversity,
          selectedSecondLanguage: this.state.selectedSecondLanguage,

          selectedThirdMajor: this.state.selectedThirdMajor,
          selectedThirdUniversity: this.state.selectedThirdUniversity,
          selectedThirdLanguage: this.state.selectedThirdLanguage,
          selectedProgram: 1,
        });
      })
      .catch((err) => console.log(err));
  }

  fetchThirdMajor2(collegeId) {
    fetch(
      `${process.env.REACT_APP_API_URL}/api/AcademicInterest/GetMajors?collegeId=${collegeId}`
    )
      .then((res) => res.json())
      .then((res) => {
        this.setState({ majorsThirdData: res });
        this.setState({
          selectedThirdMajor: this.props.selectedThirdMajor,
          loading: false,
          selectedThirdLanguage: this.props.selectedThirdLanguage,
          majorCount: 3,
        });
        this.props.collectState("AI", {
          selectedEntryTerm: this.state.selectedEntryTerm,
          selectedMajor: this.state.selectedMajor,
          selectedUniversity: this.state.selectedUniversity,
          selectedLanguage: this.state.selectedLanguage,

          selectedSecondMajor: this.state.selectedSecondMajor,
          selectedSecondUniversity: this.state.selectedSecondUniversity,
          selectedSecondLanguage: this.state.selectedSecondLanguage,

          selectedThirdMajor: this.state.selectedThirdMajor,
          selectedThirdUniversity: this.state.selectedThirdUniversity,
          selectedThirdLanguage: this.state.selectedThirdLanguage,
          selectedProgram: 1,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  fetchThirdMajor(collegeId) {
    fetch(
      `${process.env.REACT_APP_API_URL}/api/AcademicInterest/GetMajors?collegeId=${collegeId}`
    )
      .then((res) => res.json())
      .then((res) => {
        this.setState({ majorsThirdData: res });

        this.setState({
          selectedThirdMajor: "",
          selectedThirdLanguage: "",
          loading: false,
        });

        this.props.collectState("AI", {
          selectedEntryTerm: this.state.selectedEntryTerm,
          selectedMajor: this.state.selectedMajor,
          selectedUniversity: this.state.selectedUniversity,
          selectedLanguage: this.state.selectedLanguage,

          selectedSecondMajor: this.state.selectedSecondMajor,
          selectedSecondUniversity: this.state.selectedSecondUniversity,
          selectedSecondLanguage: this.state.selectedSecondLanguage,

          selectedThirdMajor: "",
          selectedThirdUniversity: this.state.selectedThirdUniversity,
          selectedThirdLanguage: "",
          selectedProgram: 1,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }
  // #endregion

  render() {
    const validationError = this.props.error;
    const {
      loading,
      error,
      entryTermData,
      selectedEntryTerm,
      universityData,

      selectedUniversity,
      selectedMajor,
      selectedLanguage,
      languagesData,
      majorsData,

      selectedSecondUniversity,
      selectedSecondMajor,
      selectedSecondLanguage,
      majorsSecondData,
      languagesSecondData,

      selectedThirdUniversity,
      selectedThirdMajor,
      selectedThirdLanguage,
      majorsThirdData,
      languagesThirdData,
    } = this.state;

    if (loading) {
      return <Loading />;
    }
    return (
      <div id="height">
        <div>
          {error && <p style={{ color: "red" }}>{error}</p>}
          <p>
            In this section, indicate your choice of major and language of
            instruction. When ready, click Next to navigate to the next section.
          </p>
          <p>When selecting your Major(s): </p>
          <ul>
            <li>
              The order of your major choices is important, as acceptances will
              be based on this order.
            </li>
            <li>
              The language of instruction will be automatically displayed under
              the selected major
            </li>
            <li>You may apply to a maximum of three majors</li>
          </ul>
          <div>
            <InputRow
              name="select"
              rowName="Expected Term to join LGU"
              value={selectedEntryTerm}
              required="*"
              hover="Please select the term you are interested in."
              errMsg={
                validationError.selectedEntryTerm
                  ? validationError.selectedEntryTerm
                  : ""
              }
              data={entryTermData}
              onChange={(e) => {
                this.setState({ selectedEntryTerm: e });
                this.props.collectState("AI", {
                  selectedEntryTerm: e,

                  selectedMajor: selectedMajor,
                  selectedUniversity: selectedUniversity,
                  selectedLanguage: selectedLanguage,

                  selectedSecondMajor: selectedSecondMajor,
                  selectedSecondUniversity: selectedSecondUniversity,
                  selectedSecondLanguage: selectedSecondLanguage,

                  selectedThirdMajor: selectedThirdMajor,
                  selectedThirdUniversity: selectedThirdUniversity,
                  selectedThirdLanguage: selectedThirdLanguage,
                  selectedProgram: 1,
                });
              }}
            />

            <div style={{ marginTop: 20 }} />
            <div className="primary-main-td-wrapper">
              <div className="primary-wrapper">
                <span className="primary-txt" style={{ fontSize: 18 }}>
                  First choice of Major
                </span>
              </div>
            </div>
            <InputRow
              name="select"
              rowName="Faculty"
              required="*"
              value={selectedUniversity}
              hover="Please select the faculty you are applying for."
              errMsg={
                validationError.selectedUniversity
                  ? validationError.selectedUniversity
                  : ""
              }
              data={universityData}
              onChange={(e) => {
                this.handleCollegeSelect(e);
                this.setState({ selectedUniversity: e });
                this.props.collectState("AI", {
                  selectedEntryTerm: selectedEntryTerm,

                  selectedMajor: selectedMajor,
                  selectedUniversity: e,
                  selectedLanguage: selectedLanguage,

                  selectedSecondMajor: selectedSecondMajor,
                  selectedSecondUniversity: selectedSecondUniversity,
                  selectedSecondLanguage: selectedSecondLanguage,

                  selectedThirdMajor: selectedThirdMajor,
                  selectedThirdUniversity: selectedThirdUniversity,
                  selectedThirdLanguage: selectedThirdLanguage,
                  selectedProgram: 1,
                });

                this.setState({ selectedUniversity: e, selectedMajor: "" });
              }}
            />

            <InputRow
              name="select"
              rowName="Degree/Program"
              value={selectedMajor}
              required="*"
              errMsg={
                validationError.selectedMajor
                  ? validationError.selectedMajor
                  : ""
              }
              data={majorsData}
              onChange={(e) => {
                const {
                  selectedMajor,
                  selectedSecondMajor,
                  selectedThirdMajor,
                } = this.state;

                if (
                  e === selectedMajor ||
                  e === selectedSecondMajor ||
                  e === selectedThirdMajor
                ) {
                  alert("This major is already selected.");
                  this.setState({ selectedMajor: "" });
                  return;
                }
                this.fetchLanguage(e);
                this.props.collectState("AI", {
                  selectedEntryTerm: selectedEntryTerm,

                  selectedMajor: e,
                  selectedUniversity: selectedUniversity,
                  selectedLanguage: this.state.selectedLanguage,

                  selectedSecondMajor: selectedSecondMajor,
                  selectedSecondUniversity: selectedSecondUniversity,
                  selectedSecondLanguage: selectedSecondLanguage,

                  selectedThirdMajor: selectedThirdMajor,
                  selectedThirdUniversity: selectedThirdUniversity,
                  selectedThirdLanguage: selectedThirdLanguage,

                  selectedProgram: 1,
                });
                this.setState({
                  selectedMajor: e,
                });
              }}
            />

            <InputRow
              name="select"
              rowName="Language"
              required="*"
              value={selectedLanguage}
              hover="Please select the language you are applying for."
              errMsg={
                validationError.selectedLanguage
                  ? validationError.selectedLanguage
                  : ""
              }
              data={languagesData}
              onChange={(e) => {
                this.setState({ selectedLanguage: e });
                this.props.collectState("AI", {
                  selectedEntryTerm: selectedEntryTerm,

                  selectedMajor: selectedMajor,
                  selectedUniversity: selectedUniversity,
                  selectedLanguage: e,

                  selectedSecondMajor: selectedSecondMajor,
                  selectedSecondUniversity: selectedSecondUniversity,
                  selectedSecondLanguage: selectedSecondLanguage,

                  selectedThirdMajor: selectedThirdMajor,
                  selectedThirdUniversity: selectedThirdUniversity,
                  selectedThirdLanguage: selectedThirdLanguage,

                  selectedProgram: 1,
                });
              }}
            />
          </div>
          {this.state.majorCount >= 2 && (
            <div style={{ marginTop: 20 }}>
              <div
                style={{
                  marginTop: 20,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <span className="primary-txt" style={{ fontSize: 18 }}>
                  Second choice of Major
                </span>
                <button
                  className="save"
                  style={{
                    width: 40,
                    height: 30,
                    minWidth: 40,
                    minHeight: 30,
                    padding: 0,
                    borderRadius: "50%",
                    backgroundColor: "#E94E1B",
                    border: "none",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onClick={() => {
                    this.setState({ majorCount: 1 });
                  }}
                  type="button"
                >
                  <span style={{ color: "white", fontSize: 16 }}>x</span>
                </button>
              </div>
              <InputRow
                name="select"
                rowName="Faculty"
                required="*"
                value={selectedSecondUniversity}
                hover="Please select the faculty you are applying for."
                errMsg={
                  validationError.selectedSecondUniversity
                    ? validationError.selectedSecondUniversity
                    : ""
                }
                data={universityData}
                onChange={(e) => {
                  this.handleSecondCollegeSelect(e);
                  this.setState({ selectedSecondUniversity: e });
                  this.props.collectState("AI", {
                    selectedEntryTerm: selectedEntryTerm,

                    selectedMajor: selectedMajor,
                    selectedUniversity: selectedUniversity,
                    selectedLanguage: selectedLanguage,

                    selectedSecondMajor: selectedSecondMajor,
                    selectedSecondUniversity: e,
                    selectedSecondLanguage: selectedSecondLanguage,

                    selectedThirdMajor: selectedThirdMajor,
                    selectedThirdUniversity: selectedThirdUniversity,
                    selectedThirdLanguage: selectedThirdLanguage,
                    selectedProgram: 1,
                  });

                  this.setState({
                    selectedSecondUniversity: e,
                    selectedSecondMajor: "",
                  });
                }}
              />

              <InputRow
                name="select"
                rowName="Degree/Program"
                value={selectedSecondMajor}
                required="*"
                errMsg={
                  validationError.selectedSecondMajor
                    ? validationError.selectedSecondMajor
                    : ""
                }
                data={majorsSecondData}
                onChange={(e) => {
                  const {
                    selectedMajor,
                    selectedSecondMajor,
                    selectedThirdMajor,
                  } = this.state;

                  if (
                    e === selectedMajor ||
                    e === selectedSecondMajor ||
                    e === selectedThirdMajor
                  ) {
                    alert("This major is already selected.");
                    this.setState({ selectedSecondMajor: "" });
                    return;
                  }
                  this.fetchSecondLanguage(e);
                  this.props.collectState("AI", {
                    selectedEntryTerm: selectedEntryTerm,

                    selectedMajor: selectedMajor,
                    selectedUniversity: selectedUniversity,
                    selectedLanguage: selectedLanguage,

                    selectedSecondMajor: e,
                    selectedSecondUniversity: selectedSecondUniversity,
                    selectedSecondLanguage: this.state.selectedSecondLanguage,

                    selectedThirdMajor: selectedThirdMajor,
                    selectedThirdUniversity: selectedThirdUniversity,
                    selectedThirdLanguage: selectedThirdLanguage,

                    selectedProgram: 1,
                  });
                  this.setState({
                    selectedSecondMajor: e,
                  });
                }}
              />

              <InputRow
                name="select"
                rowName="Language"
                required="*"
                value={selectedSecondLanguage}
                hover="Please select the language you are applying for."
                errMsg={
                  validationError.selectedSecondLanguage
                    ? validationError.selectedSecondLanguage
                    : ""
                }
                data={languagesSecondData}
                onChange={(e) => {
                  this.setState({ selectedSecondLanguage: e });
                  this.props.collectState("AI", {
                    selectedEntryTerm: selectedEntryTerm,

                    selectedMajor: selectedMajor,
                    selectedUniversity: selectedUniversity,
                    selectedLanguage: selectedLanguage,

                    selectedSecondMajor: selectedSecondMajor,
                    selectedSecondUniversity: selectedSecondUniversity,
                    selectedSecondLanguage: e,

                    selectedThirdMajor: selectedThirdMajor,
                    selectedThirdUniversity: selectedThirdUniversity,
                    selectedThirdLanguage: selectedThirdLanguage,

                    selectedProgram: 1,
                  });
                }}
              />
            </div>
          )}
          {this.state.majorCount >= 3 && (
            <div style={{ marginTop: "30px" }}>
              <div
                style={{
                  marginTop: 20,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <span className="primary-txt" style={{ fontSize: 18 }}>
                  Third Choice of Major
                </span>
                <button
                  className="save"
                  style={{
                    width: 40,
                    height: 30,
                    minWidth: 40,
                    minHeight: 30,
                    padding: 0,
                    borderRadius: "50%",
                    backgroundColor: "#E94E1B",
                    border: "none",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onClick={() => {
                    this.setState({ majorCount: 2 });
                  }}
                  type="button"
                >
                  <span style={{ color: "white", fontSize: 16 }}>x</span>
                </button>
              </div>
              <InputRow
                name="select"
                rowName="Faculty"
                required="*"
                value={selectedThirdUniversity}
                hover="Please select the faculty you are applying for."
                errMsg={
                  validationError.selectedThirdUniversity
                    ? validationError.selectedThirdUniversity
                    : ""
                }
                data={universityData}
                onChange={(e) => {
                  this.handleThirdCollegeSelect(e);
                  this.setState({ selectedThirdUniversity: e });
                  this.props.collectState("AI", {
                    selectedEntryTerm: selectedEntryTerm,

                    selectedMajor: selectedMajor,
                    selectedUniversity: selectedUniversity,
                    selectedLanguage: selectedLanguage,

                    selectedSecondMajor: selectedSecondMajor,
                    selectedSecondUniversity: selectedSecondUniversity,
                    selectedSecondLanguage: selectedSecondLanguage,

                    selectedThirdMajor: selectedThirdMajor,
                    selectedThirdUniversity: e,
                    selectedThirdLanguage: selectedThirdLanguage,

                    selectedProgram: 1,
                  });

                  this.setState({
                    selectedThirdUniversity: e,
                    selectedThirdMajor: "",
                  });
                }}
              />

              <InputRow
                name="select"
                rowName="Degree/Program"
                value={selectedThirdMajor}
                required="*"
                errMsg={
                  validationError.selectedThirdMajor
                    ? validationError.selectedThirdMajor
                    : ""
                }
                data={majorsThirdData}
                onChange={(e) => {
                  const {
                    selectedMajor,
                    selectedSecondMajor,
                    selectedThirdMajor,
                  } = this.state;

                  if (
                    e === selectedMajor ||
                    e === selectedSecondMajor ||
                    e === selectedThirdMajor
                  ) {
                    alert("This major is already selected.");
                    this.setState({ selectedThirdMajor: "" });
                    return;
                  }
                  this.fetchThirdLanguage(e);
                  this.props.collectState("AI", {
                    selectedEntryTerm: selectedEntryTerm,

                    selectedMajor: selectedMajor,
                    selectedUniversity: selectedUniversity,
                    selectedLanguage: selectedLanguage,

                    selectedSecondMajor: selectedSecondMajor,
                    selectedSecondUniversity: selectedSecondUniversity,
                    selectedSecondLanguage: selectedSecondLanguage,

                    selectedThirdMajor: e,
                    selectedThirdUniversity: selectedThirdUniversity,
                    selectedThirdLanguage: this.state.selectedThirdLanguage,
                    selectedProgram: 1,
                  });
                  this.setState({
                    selectedThirdMajor: e,
                  });
                }}
              />

              <InputRow
                name="select"
                rowName="Language"
                required="*"
                value={selectedThirdLanguage}
                hover="Please select the language you are applying for."
                errMsg={
                  validationError.selectedThirdLanguage
                    ? validationError.selectedThirdLanguage
                    : ""
                }
                data={languagesThirdData}
                onChange={(e) => {
                  this.setState({ selectedThirdLanguage: e });
                  this.props.collectState("AI", {
                    selectedEntryTerm: selectedEntryTerm,

                    selectedMajor: selectedMajor,
                    selectedUniversity: selectedUniversity,
                    selectedLanguage: selectedLanguage,

                    selectedSecondMajor: selectedSecondMajor,
                    selectedSecondUniversity: selectedSecondUniversity,
                    selectedSecondLanguage: selectedSecondLanguage,

                    selectedThirdMajor: selectedThirdMajor,
                    selectedThirdUniversity: selectedThirdUniversity,
                    selectedThirdLanguage: e,

                    selectedProgram: 1,
                  });
                }}
              />
            </div>
          )}
        </div>

        <button
          className="save"
          disabled={this.state.majorCount >= 3}
          onClick={() => {
            if (this.state.majorCount < 3) {
              this.setState({ majorCount: this.state.majorCount + 1 });
            }
          }}
          type="button"
        >
          Add Major
        </button>

        <button
          className="save"
          onClick={() => {
            this.props.onSave();
          }}
        >
          Next
        </button>
      </div>
    );
  }
}
AcademicInterest.propTypes = {
  onSave: PropTypes.func.isRequired,
  incompleteApplicationId: PropTypes.number.isRequired,
  selectedUniversity: PropTypes.number,
  selectedMajor: PropTypes.number,
  selectedLanguage: PropTypes.number,

  selectedSecondUniversity: PropTypes.number,
  selectedSecondMajor: PropTypes.number,
  selectedSecondLanguage: PropTypes.number,

  selectedThirdUniversity: PropTypes.number,
  selectedThirdMajor: PropTypes.number,
  selectedThirdLanguage: PropTypes.number,

  entryTerm: PropTypes.number,
  collectState: PropTypes.func,
  error: PropTypes.object,
};
